<script setup lang="ts">
import appleAppStoreLogo from "@/images/logo-apple-app-store.svg";
import googlePlayStoreLogo from "@/images/logo-google-play-store.svg";

const { t } = useI18n();

const appStoreUrl = "https://apps.apple.com/de/app/fobizz/id6755465996";
const googlePlayUrl =
  "https://play.google.com/store/apps/details?id=com.skills101.fobizz";
</script>

<template>
  <a
    :href="appStoreUrl"
    target="_blank"
    rel="noopener"
    :aria-label="t('footer.appStoreAriaLabel')"
  >
    <img :src="appleAppStoreLogo" width="120" height="40" alt="" />
  </a>
  <a
    :href="googlePlayUrl"
    target="_blank"
    rel="noopener"
    :aria-label="t('footer.googlePlayAriaLabel')"
  >
    <img :src="googlePlayStoreLogo" width="120" height="40" alt="" />
  </a>
</template>
